module.exports = __webpack_public_path__ + "static/img/poweredby@2x.9182b71.png";